// src/config/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions } from 'firebase/functions'; 

// Firebase configuration for the "littlehibba" project
const firebaseConfig = {
  apiKey: "AIzaSyBM33OiY0sYDD_wCXenAaLJmBQd72ZiE0w",
  authDomain: "littlehibba.firebaseapp.com",
  projectId: "littlehibba",
  storageBucket: "littlehibba.firebasestorage.app",
  messagingSenderId: "7360629299",
  appId: "1:7360629299:web:e42f728dfbb0dc65847146"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore, Storage, and Auth
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const functions = getFunctions(app, 'europe-west2');

// Export all initialized instances
export { db, storage, auth, functions };